import type { ConnectHandoffAnalyticsEvent, ConnectHandoffSource } from '@/lib/play/connectHandoffTypes'

const ALLOWED_EVENTS = new Set<ConnectHandoffAnalyticsEvent>([
  'play_connect_link_opened',
  'play_connect_continue_clicked',
  'play_connect_resume_created',
  'play_connect_resume_attached',
  'play_connect_onboarding_resumed',
  'play_connect_completed',
])

type SafeAnalyticsMeta = {
  source?: ConnectHandoffSource
  outcome?: string
}

/**
 * Fire-and-forget Connect funnel analytics. Never includes tokens, resumeRef, or PII.
 */
export function trackConnectHandoffEvent(
  event: ConnectHandoffAnalyticsEvent,
  meta?: SafeAnalyticsMeta
): void {
  if (!ALLOWED_EVENTS.has(event)) return
  if (typeof window === 'undefined') return

  const body = JSON.stringify({
    event,
    source: meta?.source,
    outcome: meta?.outcome,
  })

  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' })
      navigator.sendBeacon('/api/play/connect/handoff/event', blob)
      return
    }
  } catch {
    // fall through
  }

  void fetch('/api/play/connect/handoff/event', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
    credentials: 'same-origin',
  }).catch(() => {
    // analytics must not block UX
  })
}
